<template>
  <div data-testid="product-badges" class="flex gap-1">
    <span
      v-if="product.isNew"
      class="w-fit rounded-[4px] bg-green-500 p-1 font-rubik text-sm leading-none text-white"
    >
      {{ t('badge_labels.new') }}
    </span>
    <div v-if="relativeReductions.length" class="flex w-fit gap-1">
      <span
        v-for="({ value, category }, index) in relativeReductions"
        :key="`${value}-badge-${category}-${index}`"
        class="w-fit rounded-[4px] bg-red-700 p-1 font-rubik text-sm leading-none text-white"
      >
        -{{ value }}%
      </span>
    </div>
    <span
      v-if="isSnipesExclusive"
      class="w-fit rounded-[4px] bg-anthracite-500 p-1 font-rubik text-sm leading-none text-white"
    >
      {{ t('badge_labels.snipes_exclusive') }}
    </span>
    <span
      v-if="isOnlineExclusive"
      class="w-fit rounded-[4px] bg-anthracite-450 p-1 font-rubik text-sm leading-none text-white"
    >
      {{ t('badge_labels.online_exclusive') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { type Product, getFirstAttributeValue } from '@scayle/storefront-nuxt'
import { useI18n } from '#i18n'
import { useProductPrice } from '#storefront/composables'
import { useProductBaseInfo } from '~/composables'

const { product } = defineProps<{ product: Product }>()

const { t } = useI18n()
const { price } = useProductBaseInfo(() => product)
const { relativeReductions } = useProductPrice(price.value)

const isOnlineExclusive =
  getFirstAttributeValue(product.attributes, 'onlineExclusiveFilter')?.value ===
  'yes'

const isSnipesExclusive =
  getFirstAttributeValue(product.attributes, 'isExclusive')?.value === 'yes'
</script>
